import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { TIDS } from '../constants/testIds';

const HowItWorks = () => {
  const { t } = useI18n();

  return (
    <section
      id="how"
      data-testid={TIDS.howSection}
      className="py-24 sm:py-32 bg-[#F5F5F7]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-[#0071E3] text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase">
            {t.how.title}
          </p>
          <h2 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#1D1D1F] leading-tight">
            {t.how.subtitle}
          </h2>
        </motion.div>

        <div className="mt-14 sm:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.how.steps.map((step, i) => (
            <motion.div
              key={step.title}
              data-testid={TIDS.howStep(i + 1)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white rounded-[2rem] p-8 relative overflow-hidden flex flex-col"
            >
              <span className="text-6xl font-extrabold text-[#0071E3]/10 tracking-tighter leading-none">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-xl font-bold tracking-tight text-[#1D1D1F] leading-snug">
                {step.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-[#86868B]">
                {step.desc}
              </p>
              {step.bullets && step.bullets.length > 0 && (
                <ul className="mt-5 space-y-2">
                  {step.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-[14px] text-[#1D1D1F]">
                      <span className="mt-[3px] shrink-0 inline-flex items-center justify-center w-4 h-4 rounded-full bg-[#0071E3]/10 text-[#0071E3]">
                        <Check className="w-3 h-3" strokeWidth={3} />
                      </span>
                      <span className="leading-snug">{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
